import { createSelector } from "reselect";
import { IRootObject } from "./types";
import get from "lodash/get";

export const i18n = (state: { internationalization: IRootObject }): IRootObject =>
    state.internationalization;

export const getUserI18N = createSelector(
    [i18n],
    (
        response
    ): {
        countryCode: string;
        country: string;
        currency: string;
        currencyDisplayValue: string;
        hasUpdatedI18n: boolean;
        flagUrl: string;
    } => ({
        country: response.country,
        countryCode: response.countryCode,
        currency: response.currency,
        currencyDisplayValue: response.currencyDisplayValue,
        hasUpdatedI18n: response.hasUpdatedI18n,
        flagUrl: response.flagUrl,
    })
);

export const getCountries = createSelector(
    [i18n],
    response =>
        response.countries.map(country => {
            return {
                name: country.countryName,
                value: country.countryCode,
                flagUrl: country.flagUrl || "",
            };
        })
);

// TODO - remove normalization from selectors
export const getCurrenciesRaw = createSelector(
    [i18n],
    response => response.currencies
);

export const getCurrencies = createSelector(
    [i18n],
    response =>
        response.currencies.map(currency => {
            return {
                name: `${currency.currencyCode} ${
                    currency.currencyDisplayValue !== currency.currencyCode
                        ? "(" + currency.currencyDisplayValue + ")"
                        : ""
                }`,
                value: currency.currencyCode,
            };
        })
);

export const onGDPRNetwork = createSelector(
    [i18n],
    (response): boolean => get(response, "onGDPRNetwork", false)
);

export const getXHRStatus = createSelector(
    [i18n],
    (response): boolean => response.isXHRAllowed
);
